export const PROPERTY_LISTING_BATCH_KEY = 'property-listing';
